import Routes from '@components/Routes/Routes';
import AuthorizationGuard from '@components/Auth/AuthorizationGuard';
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Footer } from './Footer';
import TopHeader from './TopHeader';

const theme = {
  primaryColor: '#05c3de',
  primary: '#05c3de',
  secondary: '#777',
  tertiary: 'green',
  danger: 'red',
  baseFontColor: '#333',
  brandGrey: '#777',
  baseFontSize: '16px',
  buttonFontSize: '14px',
  fontSemibold: '600',
  baseRadius: '4px'
};

// Same look as the MUI <Paper> (elevation 1) these containers used before MUI was removed
const Paper = styled.div`
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

const StyledAppContainer = styled(Paper)`
  height: 100%;
  display: grid;
  grid-template-areas:
    'head  head'
    'navigation  navigation'
    'main main'
    'foot  foot';
  grid-template-rows: auto auto 1fr auto;
  grid-template-columns: 1fr;
`;

const NavContainer = styled(Paper)`
  grid-area: navigation;
`;

const ViewContainer = styled(Paper)`
  grid-area: main;
`;

const FooterContainer = styled(Paper)`
  grid-area: foot;
`;

const App: React.FC = () => {
  return (
    <AuthorizationGuard>
      <ThemeProvider theme={theme}>
        <StyledAppContainer>
          <TopHeader />
          <ViewContainer>
            <Routes />
          </ViewContainer>
          <FooterContainer>
            <Footer />
          </FooterContainer>
        </StyledAppContainer>
      </ThemeProvider>
    </AuthorizationGuard>
  );
};

export default App;
